<template>
  <div>
    <div
      id="hubspotForm"
      v-bind:class="`${isFormActive ? 'hubspotFormActive' : 'hubspotFormInActive'} `"
      v-once>
    </div>
  </div>
</template>

<script>
import { SEGMENT_EVENTS } from '../constants'
export default {
  name: 'Footer',
  props: {
    isFormActive: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    let script = document.createElement('script')
    script.setAttribute('src', '//js.hsforms.net/forms/v2.js')
    document.head.appendChild(script)
    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "3821121",
          formId: "6d58b7f3-fd47-4d72-9b30-4ea573469876", // maybe good to move to env vars
          target: "#hubspotForm",
          region: "na1",
        })
      }
    });
    window.addEventListener('message', event => {
      if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
        let data = {};
        if (event.data.data && event.data.data.length) {
          event.data.data.forEach(({ name, value }) => {
            data[name] = value;
          })
        }
        window.analytics.track(SEGMENT_EVENTS.SUBMIT_NEED_A_HAND, data)
        setTimeout(()=>{
          this.$emit('closeHubSpot');
          window.hbspt.forms.create({
            portalId: "3821121",
            formId: "6d58b7f3-fd47-4d72-9b30-4ea573469876",
            target: "#hubspotForm",
            region: "na1",
          })
        }, 5000)
      }
    });
  },
}
</script>

<style scoped>
#hubspotForm {
  float: right;
  position: absolute;
  background-color: #cec;
  right: 3px;
  bottom: 56px;
  padding: 10px;
  box-shadow: 0px 2px 10px rgb(0 0 0 / 8%);
  border-radius: 4px;
  margin-right: 30px;
  width: 291px;
}
#hubspotForm >>> form {
  padding: 10px;
}
#hubspotForm >>> form .hs-input {
  background-color: #fff;
  width: 100%;
}
#hubspotForm >>> form .hs-button {
  background-color: #eee;
  padding: 10px 20px;
  color: #fff;
}
#hubspotForm >>> form .hs-error-msgs {
  text-align: left;
}
#hubspotForm >>> form .invalid.error {
  background-color: #fff!important;
  border: 1px solid red;
}
</style>
